export default __webpack_public_path__ + "static/media/36I-114285_-20963_0.fc476c45.jpg";